import { atom } from 'jotai'
import { type ToastState } from '@/features/shared/state/Toast/types'

export const initialToastState: ToastState = {
  appear: false,
  data: {},
  meta: {
    toastType: '',
  },
}

export const toastAtom = atom(initialToastState)
toastAtom.debugLabel = 'toastAtom'
